import { Save, Download } from 'lucide-react';
import { useProjectStore } from '../../store/projectStore';

export function Footer() {
  const hasUnsavedChanges = useProjectStore((state) => state.hasUnsavedChanges);
  const exportProject = useProjectStore((state) => state.exportProject);

  return (
    <footer className="h-11 bg-white dark:bg-slate-900 border-t border-slate-200 dark:border-slate-700 flex items-center justify-between px-4 shrink-0 text-sm">
      <div className="flex items-center gap-2 text-slate-500 dark:text-slate-400">
        <Save size={14} />
        <span>{hasUnsavedChanges ? '自動保存中...' : '已自動保存'}</span>
      </div>
      <div className="flex items-center gap-2">
        <span className="hidden sm:inline text-xs text-slate-400">PromptForge v1.0</span>
        <button
          type="button"
          onClick={exportProject}
          className="flex items-center gap-1.5 px-3 py-1 text-xs rounded-md bg-slate-900 hover:bg-slate-800 text-white transition-colors"
        >
          <Download size={12} />
          導出全部
        </button>
      </div>
    </footer>
  );
}
